import { Nullable } from "web/types/Utils";

export const enum CodeActionType {
  SET_CAN_PRINT = "SET_CAN_PRINT",
  GET_CAN_PRINT = "GET_CAN_PRINT",
  SET_CODE = "SET_CODE",
  GET_CODE = "GET_CODE",
  SET_BARCODE = "SET_BARCODE",
  GET_BARCODE = "GET_BARCODE",
}

interface IGetCodeActionArgs {
  action:
    | CodeActionType.GET_BARCODE
    | CodeActionType.GET_CAN_PRINT
    | CodeActionType.GET_CODE;
  itemId: number;
}

interface ISetCodeActionArgs {
  action:
    | CodeActionType.SET_BARCODE
    | CodeActionType.SET_CAN_PRINT
    | CodeActionType.SET_CODE;
  value: string | boolean;
  itemId: number;
}

export interface HandleCodeSessionStorageAction {
  (args: IGetCodeActionArgs): Nullable<string>;
  (args: ISetCodeActionArgs): void;
}

const handleCodeSessionStorageAction: HandleCodeSessionStorageAction = ({
  itemId,
  ...args
}) => {
  switch (args.action) {
    case CodeActionType.SET_CAN_PRINT:
      sessionStorage.setItem(`${itemId}_CAN_PRINT`, `${args.value}`);
      return null;
    case CodeActionType.GET_CAN_PRINT:
      return sessionStorage.getItem(`${itemId}_CAN_PRINT`);
    case CodeActionType.SET_CODE:
      sessionStorage.setItem(`${itemId}_PRODUCT_CODE`, `${args.value}`);
      return null;
    case CodeActionType.GET_CODE:
      return sessionStorage.getItem(`${itemId}_PRODUCT_CODE`);
    case CodeActionType.SET_BARCODE:
      sessionStorage.setItem(`${itemId}_BARCODE`, `${args.value}`);
      return null;
    case CodeActionType.GET_BARCODE:
      return sessionStorage.getItem(`${itemId}_BARCODE`);
    default:
      return null;
  }
};

export default handleCodeSessionStorageAction;
